import Constants from "../Constants";
import Translator from "../../Translation/Translator";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import { ActionInterface } from "../../Interface/ActionInterface";

class UserActions {

  public auth(user: PersonInterface, settings: UserSettingsInterface): ActionInterface {
    // Use the user's language.
    Translator.use(settings && settings.language && settings.language.iso);

    return {
      type: Constants.AUTH_SIGNIN,
      payload: {
        user: user,
        settings: settings
      }
    };
  }

  public signout(payload?): ActionInterface {
    return {
      type: Constants.AUTH_SIGNOUT,
      payload: payload ? payload : {}
    };
  }
}

export default new UserActions();
